require('./angular-animate');
module.exports = 'ngAnimate';



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/~/angular-animate/index.js
 ** module id = 196
 ** module chunks = 0
 **/